import { mnemonicToSeedSync as bip39MnemonicToSeedSync } from "@scure/bip39";
import { toHEX } from "../utils/index.js";
function isValidHardenedPath(path) {
  return /^m\/44'\/784'\/[0-9]+'\/[0-9]+'\/[0-9]+'+$/.test(path);
}
function isValidBIP32Path(path) {
  return !/^m\/(54|74)'\/784'\/[0-9]+'\/[0-9]+\/[0-9]+$/.test(path);
}
function mnemonicToSeed(mnemonics) {
  return bip39MnemonicToSeedSync(mnemonics, "");
}
function mnemonicToSeedHex(mnemonics) {
  return toHEX(mnemonicToSeed(mnemonics));
}
export {
  isValidBIP32Path,
  isValidHardenedPath,
  mnemonicToSeed,
  mnemonicToSeedHex
};
//# sourceMappingURL=mnemonics.js.map
